var app = angular.module('leonardo');

var OnDemandInstructionService = function(BaseRestService, RestangularProvider) {

  var service = new BaseRestService('on-demand-instructions', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('on-demand-instructions', false, function(instruction) {
      instruction.addRestangularMethod('cloneToWhiteLabel', 'post', 'clone-to-whitelabel');
      return instruction;
    });
  });

  service.unread = function(params) {
    return RestangularProvider.all('on-demand-instructions').customGET('unread', params);
  };

  service.getReports = function(params) {
    return RestangularProvider.all('on-demand-instructions').customGET('report', params);
  };

  service.getEmails = function(params) {
    return RestangularProvider.all('on-demand-instructions').customPOST(params, 'emails');
  };

  service.bulkObject = function() {
    return {
      name: '',
      category: null,
      image: null,
      body: '',
      teaser: ''
    };
  };

  return service;
};

app.factory('OnDemandInstructionService', ['BaseRestService', 'Restangular', OnDemandInstructionService]);
